import { emojiDefaults } from "@/components/emoji/emoji.type.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";
import { SelectItem } from "@skailer-com/uikit";
import i18n from "i18next";

export enum TeamMemberRoleType {
  member = "member",
  team_leader = "team_leader",
}

export type TeamMemberRoleItem = SelectItem;
export const TeamMemberRoleItems = () => {
  return [
    {
      id: TeamMemberRoleType.member,
      title: i18n.t("core:member"),
    },
    {
      id: TeamMemberRoleType.team_leader,
      title: i18n.t("core:team_lead"),
    },
  ] as TeamMemberRoleItem[];
};

export interface ApiTeam {
  id: number;
  title: string;
  description?: string;
  emoji: string;
  background_url?: string | null;
  links: ApiTeamLink[];
  members: ApiTeamMember[];
}

export interface ApiTeamLink {
  title: string;
  url: string;
}

export interface ApiTeamMember {
  id: number;
  employee: ApiEmployee;
  sort: number;
  role: TeamMemberRoleType;
  description?: string;
}

export interface ApiTeamFilter extends ApiFilterBase {
  text?: string;
  employee_ids?: number[];
}

export const TeamFilterDefault: ApiTeamFilter = {
  page_number: 1,
};

export interface ApiTeamSavePayload {
  title: string;
  description?: string | null;
  emoji: string;
  links?: ApiTeamLinkSavePayload[];
  members?: ApiTeamMemberSave[];
}

export interface ApiTeamLinkSavePayload {
  title: string;
  url: string;
}

export interface ApiTeamMemberSave {
  employee_id: number;
  role: TeamMemberRoleType;
  description?: string;
}

export const getTeamEmoji = (team: ApiTeam | undefined) => {
  return team?.emoji || emojiDefaults.team.default;
};
